/**
 * Chat panel (legacy ChatPanel, shared chat components). Keys must match ../en/chat.ts.
 *
 * Not here on purpose: text sent to the agent as context (scope descriptions in
 * ChatPanel), and brand names (DataRetriever, Hedwig, Cheetah, IVT).
 */
const chat = {
  welcome: {
    rocky: '你好！👋 我是 Rocky，有什么我可以帮你的吗？',
    marketing_agent: '你好！👋 我是 Marketing Agent，有什么我可以帮你的吗？',
    campaign_copilot_agent: '你好！👋 我是 Campaign Copilot，有什么我可以帮你的吗？',
    eval: '你好！👋 我是 Evaluation Agent，可以帮你查看评估运行、失败案例和质量趋势。有什么我可以帮你的吗？',
  },
  header: {
    title: '对话',
    historyTitle: '对话历史',
    history: '对话历史',
    backToChat: '返回对话',
    newConversation: '新对话',
    enterFullscreen: '全屏',
    exitFullscreen: '退出全屏',
    close: '关闭对话',
    open: '打开对话',
  },
  thought: {
    thinking: '思考中…',
    completed: '思考完成',
    hint: '为了数据准确性我可能会使用更长的时间，等待时您可以点击聊天窗口上方<icon />，唤起新的对话，后台任务将持续运行',
    newChatAlt: '新对话',
  },
  /** Follow-up suggestions under an answer (choice_group heading / group name). */
  followUps: {
    title: '接下来可以',
  },
  suggestions: {
    title: '推荐问题',
  },
  disclaimer: 'Rocky 是 AI，可能会出错。',
  messages: {
    loadingOlder: '正在加载更早的消息…',
    empty: '这个对话还没有消息。',
    unknownError: '未知错误',
    userAvatar: '{{name}} 的头像',
    userFallback: '用户',
    assistantAvatar: 'Rocky AI 助手的头像',
    genericAssistantAvatar: 'AI 助手的头像',
    noResponse: '（无回复）',
    stopped: '（已停止）',
    scrollToLatest: '滚动到最新消息',
  },
  errors: {
    auth: '认证失败，请刷新页面重新登录。',
    withMessage: '出错了：{{message}}',
    noResponse: '没有收到回复',
    sendFailed: '抱歉，发送失败，请重试。',
  },
  session: {
    switchConfirm: '当前对话正在连接中，切换可能丢失回复。确定切换吗？',
  },
  input: {
    model: '模型',
    placeholder: '今天有什么可以帮您？发送消息开始对话。',
    readOnly: '只读模式（管理员查看）',
    emailFallback: '不想等了，做完直接把报告和分析发我邮箱',
    willQueue: '问题将加入待发送队列…',
    gateBlocks: '请先处理上方的审批卡片（批准 / 取消）',
    gateReply: '回复上方卡片：修改意见或问题（批准请点卡片按钮）',
    stop: '停止生成',
    stopKeepQueue: '停止当前回答（队列中的问题会继续发送）',
    context: '上下文：{{percent}}%',
    send: '发送消息',
    addToQueue: '加入待发送队列',
  },
  queue: {
    gateFirst: '请先处理上方的审批卡片',
    full: '待发送队列最多 {{max}} 条',
    label: '待发送问题队列',
    remove: '移出队列',
    removeNamed: '移出队列中的问题：{{text}}',
    sendNow: '立即发送（会停止当前回答）',
    sendNowNamed: '立即发送队列中的问题：{{text}}',
  },
  files: {
    attach: '添加附件',
    attachLabel: '添加附件',
    drop: '拖放文件到这里上传',
    uploading: '上传中…',
    remove: '移除文件',
    removeNamed: '移除 {{name}}',
    unsupported: '暂不支持上传 {{exts}} 类型的文件，请转换为 PDF、CSV、TXT 等支持的格式后重试。',
    listSeparator: '、',
    openInWorkspace: '在工作区中打开',
  },
  contextFile: {
    banner: '正在围绕《<name>{{fileName}}</name>》对话',
    stopNamed: '不再以 {{fileName}} 作为上下文',
    stop: '不再以此文件作为对话上下文',
    chipExcludeTitle: '{{name}}（点击从上下文中移除）',
    chipIncludeTitle: '{{name}}（点击加入上下文）',
    chipExclude: '将 {{name}} 从上下文中移除',
    chipInclude: '将 {{name}} 加入上下文',
  },
  scope: {
    kb: 'KB: {{name}}',
    assetTitle: 'Chat 已绑定到 Asset「{{name}}」，点击退出',
    assetExit: '退出 Asset 知识库范围：{{name}}',
    useCaseTitle: 'Chat 已绑定到 Use Case「{{name}}」，点击退出',
    useCaseExit: '退出 Use Case 知识库范围：{{name}}',
    storylineTitle: 'Chat 已绑定到 Storyline「{{name}}」，点击退出',
    storylineExit: '退出 Storyline 知识库范围：{{name}}',
  },
  pack: {
    label: 'Rocky 技能包',
    agentLabel: '技能包',
    open: '打开 {{label}} 技能',
    unavailable: '{{label}}（加载中，暂不可用）',
    descriptions: {
      DataRetriever: '即时获取收入、用量、Pipeline 和客户数据，不用再翻看报表或等待取数。',
      Hedwig: '为一线团队提供情报简报：汇集行业数据和资源，呈现行业动态、竞争对手动向和客户洞察，推动下一步行动。',
      Cheetah: 'Cheetah 提供内部专家预约服务：按需匹配合适的专家，一键预约，全程跟踪协作进展。',
      IVT: '行业解决方案：浏览 Solution Map、Storyline、Asset 和 Motion，助力行业销售。',
      CampaignCopilot: '营销活动编排：圈选受众、个性化邮件、创建 Octopus 活动与效果分析。',
      EventInsights: '活动洞察：活动前后的数据分析报告。',
    },
  },
  markdown: {
    code: '代码',
    copy: '复制',
    copied: '已复制',
  },
  history: {
    loading: '正在加载对话…',
    empty: '还没有对话记录',
    untitled: '未命名对话',
    loadMore: '加载更多',
    loadingMore: '加载中…',
    loadFailed: '加载对话列表失败',
    loadMoreFailed: '加载更多对话失败',
    loadConversationFailed: '加载对话失败',
    justNow: '刚刚',
    minutesAgo: '{{n}} 分钟前',
    hoursAgo: '{{n}} 小时前',
    daysAgo: '{{n}} 天前',
  },
};

export default chat;
